module.exports = __webpack_public_path__ + "img/cooperation08.b3db629c.png";